import { FC, useMemo } from 'react';
import { usePolesContext } from '../../../modules/poles/PolesContext';
import { useTranslation } from 'react-i18next';
import { Alert } from '../../../modules/data/_models';
import { Firmware } from '../../../modules/poles/_models';

const ListItem: FC<{ alert: Alert }> = ({ alert }) => {
  const { t } = useTranslation('alerts', { keyPrefix: 'list' });
  const { currentPole } = usePolesContext();

  const keys = Object.keys(alert).filter((k) => k !== '_time');
  const key = keys[keys.length - 1] as keyof Firmware;

  const label = useMemo(() => {
    if (!currentPole?.firmware || !alert || !key || !alert[key as keyof Alert])
      return null;

    const item = alert[key as keyof Alert] as unknown as {
      trigger: string;
      value: boolean;
    };
    const name =
      currentPole.firmware[key] && 'name' in currentPole.firmware[key]
        ? currentPole.firmware[key].name
        : undefined;

    const trigger =
      item.trigger === 'change' ? (item.value ? 'on' : 'off') : item.trigger;

    if (key?.startsWith('in'))
      return t(`input.${trigger}`, {
        label: name ? name : key.replace('in', ''),
      });

    if (key?.startsWith('24out'))
      return t(`24output.${trigger}`, {
        label: name ? name : key.replace('24out', ''),
      });

    if (key?.startsWith('12out'))
      return t(`12output.${trigger}`, {
        label: name ? name : key.replace('12out', ''),
      });

    if (key?.startsWith('fan'))
      return t('fields.fan.label', {
        label: name ? name : key.replace('fan', ''),
      });

    return t(`${key}.${trigger}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, alert, currentPole?.firmware]);
  return (
    <>
      <div className="flex-shrink-1 fw-bold text-gray-800">
        {new Date(alert._time).toLocaleString() ?? ''}
      </div>

      <div className="w-100 ps-3">{label}</div>
    </>
  );
};

export default ListItem;
